import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 22.24 16.05"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M21.93.31c-.42-.41-1.09-.41-1.5 0L7.25 13.48 1.82 8.05c-.42-.41-1.09-.41-1.5 0a1.05 1.05 0 0 0 0 1.5l6.19 6.19c.21.21.48.31.75.31s.54-.1.75-.31L21.93 1.82c.42-.42.42-1.09 0-1.5Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }